define('views/base/baseLayoutView',[
    'marionette',
    'underscore'
], function (Marionette, _) {
    'use strict';
    return Marionette.LayoutView.extend(_.extend({}));
});
